import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export type StatusKind = "ok" | "warn" | "err";

const STYLE: Record<StatusKind, string> = {
  ok: "bg-green-50 text-green-700 border-green-200",
  warn: "bg-amber-100 text-amber-800 border-amber-200",
  err: "bg-red-50 text-red-700 border-red-200",
};

/**
 * Per-section validation badge — same colour ramp as the Ring 2B
 * ``.sec-status`` rule in the legacy template. Used in DocSectionCard
 * (W3) and SectionNav (W3) for at-a-glance validator status.
 */
export function BadgeStatus({
  kind,
  children,
  title,
  className,
}: {
  kind: StatusKind;
  children: ReactNode;
  title?: string;
  className?: string;
}) {
  return (
    <span
      title={title}
      className={cn(
        "inline-flex flex-shrink-0 items-center rounded px-1.5 py-0.5 text-[0.7rem] font-bold tracking-[0.02em] border",
        STYLE[kind],
        className,
      )}
    >
      {children}
    </span>
  );
}
